/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Condition { 
    nestedPath?: string;
    attribute?: string;
    value?: Array<string | number | object | boolean>;
    operator?: Condition.OperatorEnum;
}
export namespace Condition {
    export type OperatorEnum = 'eq' | 'neq' | 'gte' | 'gt' | 'lt' | 'lte' | 'btn' | 'contain' | 'startwith' | 'match' | 'AND' | 'OR';
    export const OperatorEnum = {
        Eq: 'eq' as OperatorEnum,
        Neq: 'neq' as OperatorEnum,
        Gte: 'gte' as OperatorEnum,
        Gt: 'gt' as OperatorEnum,
        Lt: 'lt' as OperatorEnum,
        Lte: 'lte' as OperatorEnum,
        Btn: 'btn' as OperatorEnum,
        Contain: 'contain' as OperatorEnum,
        Startwith: 'startwith' as OperatorEnum,
        Match: 'match' as OperatorEnum,
        AND: 'AND' as OperatorEnum,
        OR: 'OR' as OperatorEnum
    };
}


